export const ALLOWED_KTB_HOSTS = [
  "cornelsen.de",
  "production.cornelsen.de",
  "qa.cornelsen.de",
  "stage.cornelsen.de",
  "testing.cornelsen.de",
  "www.cornelsen.de",
];

export const QUERY_PARAMS = {
  IS_USER_SEARCH: "isUserSearch",
  SKIP_WEBCODE: "skipWebcode",
  VALUE_BEFORE_AUTOSUGGEST: "valueBeforeSuggest",
};
